module.exports = __webpack_public_path__ + "static/media/cy.e4ec5ff8.svg";